"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgentCredentials = void 0;
const Api_1 = __importDefault(require("./Api"));
const Log_1 = __importDefault(require("../Log"));
class AgentCredentials {
    constructor(agentToken) {
        this._accessKeyId = '';
        this._secretAccessKey = '';
        this._sessionToken = '';
        this._agentToken = agentToken;
    }
    initialize() {
        return __awaiter(this, void 0, void 0, function* () {
            Log_1.default.debug('Obtaining Agent credentials...');
            const res = yield Api_1.default.getCredentials(this._agentToken.apiEndpoint, this._agentToken.environmentId, this._agentToken.rawToken);
            yield this.parseResponse(res);
        });
    }
    get accessKeyId() {
        return this._accessKeyId;
    }
    set accessKeyId(key) {
        this._accessKeyId = key;
    }
    get secretAccessKey() {
        return this._secretAccessKey;
    }
    set secretAccessKey(key) {
        this._secretAccessKey = key;
    }
    get sessionToken() {
        return this._sessionToken;
    }
    set sessionToken(token) {
        this._sessionToken = token;
    }
    get expireTime() {
        return this._expireTime;
    }
    set expireTime(expiry) {
        this._expireTime = expiry;
    }
    get credentialsCheckTime() {
        if (this.millisecondsToExpiry < 300000) {
            return 0;
        }
        return this.millisecondsToExpiry - 300000;
    }
    get environmentId() {
        return this._agentToken.environmentId;
    }
    get region() {
        return this._region;
    }
    get graphQLEndpoint() {
        return this._graphQLEndpoint;
    }
    get messagingEndpoint() {
        return this._iotEndpoint;
    }
    get iceServers() {
        return this._iceServers;
    }
    get millisecondsToExpiry() {
        return this._expireTime.getTime() - Date.now();
    }
    get launchRequestId() {
        return this._agentToken.launchRequestId;
    }
    get modelId() {
        return this._agentToken.modelId;
    }
    refresh(callback) {
        this.refreshCredentials()
            .then(() => {
            callback();
        })
            .catch((reason) => {
            callback(new Error(reason));
        });
    }
    refreshPromise() {
        return this.refreshCredentials();
    }
    refreshCredentials() {
        return __awaiter(this, void 0, void 0, function* () {
            Log_1.default.debug('Refreshing Agent credentials...');
            const res = yield Api_1.default.refreshCredentials(this._agentToken.apiEndpoint, this._agentToken.environmentId, this._refreshToken);
            yield this.parseResponse(res);
        });
    }
    parseResponse(response) {
        return __awaiter(this, void 0, void 0, function* () {
            if (response.ok) {
                const data = yield response.json();
                this._refreshToken = data.agent.refresh_token;
                this.accessKeyId = data.agent.credentials.AccessKeyId;
                this.secretAccessKey = data.agent.credentials.SecretAccessKey;
                this.sessionToken = data.agent.credentials.SessionToken;
                this.expireTime = new Date(data.agent.credentials.Expiration);
                const { region } = data;
                const { graphqlEndpoint, iotEndpoint } = data.environment;
                this._iceServers = data.iceServers;
                this._region = region;
                this._graphQLEndpoint = graphqlEndpoint;
                this._iotEndpoint = iotEndpoint;
            }
            else {
                return Promise.reject(response.statusText);
            }
        });
    }
}
exports.AgentCredentials = AgentCredentials;
